var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$translation('button.cookieSettings'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }